import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rxcasa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const path = window.location.pathname;
    if (err?.response?.status === 401) {
      if (path.startsWith("/admin")) {
        localStorage.removeItem("rxcasa_token");
        localStorage.removeItem("rxcasa_role");
        if (path !== "/admin/login") window.location.href = "/admin/login";
      } else if (path.startsWith("/area-agenzie")) {
        localStorage.removeItem("rxcasa_token");
        localStorage.removeItem("rxcasa_role");
        if (path !== "/area-agenzie/login") window.location.href = "/area-agenzie/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Errore, riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => {
      const msg = String(e?.msg || "");
      if (msg.includes("value is not a valid email")) return "Indirizzo email non valido";
      if (msg.includes("String should have at most")) return "Testo troppo lungo";
      if (msg.includes("Field required")) return `Campo obbligatorio: ${(e?.loc || []).slice(-1)[0] || ""}`;
      if (msg.includes("Input should be a valid")) return "Valore non valido per uno dei campi";
      return msg || "Errore di validazione";
    }).join(" · ");
  }
  return String(detail);
}

export default api;
